import { Stack, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { UserConsentDetails } from "../../../../api/types/userConsentTypes";
import UserConsentCategoryTag from "./UserConsentCategoryTag";

interface Props {
  consentDetails: UserConsentDetails;
}

const UserConsentDetailsPageTitle = ({ consentDetails }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ pb: 1.5, pt: 1 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "baseline" }}>
        <Typography variant="h6">{consentDetails.name}</Typography>
        <UserConsentCategoryTag categoryId={consentDetails.categoryId} />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="caption" color="textSecondary">
          User Consent
        </Typography>
        <Typography variant="caption" color="textSecondary">
          &bull;
        </Typography>
        <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
          <Typography variant="caption" color="textSecondary">
            Modified at:
          </Typography>
          <Typography variant="caption">{convertISODateTime(consentDetails.lastModified)}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default UserConsentDetailsPageTitle;
